import React from 'react';
import FormControl from 'react-bootstrap/FormControl';

import Const from '../../util/Constants';
import RegEx from '../../util/RegEx';

class FieldEmail extends React.Component {
  
  constructor(props) {
    super(props);
    this.visible = props.field.visible === Const.True;
    this.editable = props.field.editable === Const.True;
    this.LabelName = props.field.label_name;
    this.regex = props.field.validate;
    this.Key = props.id;
    
    this.state = { value: this.props.value, inValid: this.props.inValid };
  }

  handleChange = email => {
    let inValid = { };
    if(!RegEx.isEmail(email, this.regex)) inValid[this.Key] = 'Invalid Data';
    this.props.onValueChange(this.Key, email);
    this.setState({ value: email, inValid: { ...inValid } });
  }

  render() {
    if(!this.visible || !this.editable) return null;

    let inValid = this.state.inValid;
    if(this.editable && RegEx.isKeyPresent(this.props.inValid, this.Key)) inValid = this.props.inValid;

    return (
      <div className="col">
        <div className="form-group">
          <label>{this.LabelName}</label> { RegEx.showError(inValid, this.Key) }
          <FormControl type="text" placeholder={this.LabelName} value={this.state.value}
            className={`mr-sm-2 ${RegEx.class(inValid, this.Key)}`} readOnly={!this.editable}
            onChange={event => this.handleChange(event.target.value)}/>
        </div>
      </div>
    );
  }
}
export default FieldEmail;